<template>
<div>
    <v-tooltip bottom v-if="totalCriticals > 0">
        <template v-slot:activator="{ on }">
            <v-btn icon :small="$vuetify.breakpoint.md" color="error" class="alert-button" v-on="on" @click="showTab('tab-critical')">{{ totalCriticals }}</v-btn>
        </template>
        <span>Criticals</span>
    </v-tooltip>
    <v-tooltip bottom v-if="totalWarnings > 0">
        <template v-slot:activator="{ on }">
            <v-btn icon :small="$vuetify.breakpoint.md" color="warning" class="alert-button" v-on="on" @click="showTab('tab-cautions')">{{ totalWarnings }}</v-btn>
        </template>
        <span>Cautions</span>
    </v-tooltip>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn icon :small="$vuetify.breakpoint.md" color="info" class="alert-button" v-on="on" @click="showTab('tab-notices')">{{ totalNotices }}</v-btn>
        </template>
        <span>Notices</span>
    </v-tooltip>
    <v-bottom-sheet v-model="showModal" width="800" inset @keydown.esc="showModal = false">
        <v-progress-linear :indeterminate="true" v-if="loading" class="ma-0 pa-0" color="accent"></v-progress-linear>
        <v-tabs color="primary" dark v-model="tab">            
            <v-tab ripple :href="'#tab-critical'">
                <v-icon color="error">error</v-icon>
                <span class="pl-1">Criticals</span>
            </v-tab>
            <v-tab ripple :href="'#tab-cautions'">
                <v-icon color="warning">warning</v-icon>
                <span class="pl-1">Cautions</span>
            </v-tab>
            <v-tab ripple :href="'#tab-notices'">
                <v-icon color="info">info</v-icon>
                <span class="pl-1">Notices</span>
            </v-tab>
            <v-tabs-items v-model="tab">
                <v-tab-item :value="'tab-critical'">
                    <alert-list :alerts="criticals" :categoryTotals="categoryTotals"></alert-list>
                    <v-alert class="ma-0" type="info" :value="totalCriticals == 0">No data available</v-alert>
                </v-tab-item>
                <v-tab-item :value="'tab-cautions'">
                    <alert-list :alerts="warnings" :categoryTotals="categoryTotals"></alert-list>
                    <v-alert class="ma-0" type="info" :value="totalWarnings == 0">No data available</v-alert>
                </v-tab-item>
                <v-tab-item :value="'tab-notices'">
                    <alert-list :alerts="notices" :categoryTotals="categoryTotals"></alert-list>
                    <v-alert class="ma-0" type="info" :value="totalNotices == 0">No data available</v-alert>
                </v-tab-item>
            </v-tabs-items>            
        </v-tabs>
    </v-bottom-sheet>
</div>
</template>

<script>
import AlertList from "./AlertList.vue";
import alertApi from '../../api/alertApi';

export default {
    components: {
        AlertList
    },
    data() {
        return {
            showModal: false,
            tab: "",
            criticals: [],
            warnings: [],
            notices: [],
            categoryTotals: [],
            loading: false
        }
    },
    computed: {
        totalCriticals() {
            return this.$store.getters["AlertStore/totalCriticals"];
        },
        totalWarnings() {
            return this.$store.getters["AlertStore/totalWarnings"];
        },
        totalNotices() {
            return this.$store.getters["AlertStore/totalNotices"];
        },
    },
    methods: {
        async showTab(tab) {
            this.loading = true;
            this.tab = tab;
            this.showModal = true;

            this.criticals = [];
            this.warnings = [];
            this.notices = [];

            this.categoryTotals = await alertApi.getCategories();
            let alerts = await alertApi.getAlerts();
            
            alerts.forEach(alert => {
                if(alert.Priority == 1) {
                    this.criticals.push(alert);
                } else if(alert.Priority == 2) {
                    this.warnings.push(alert);
                } else {
                    this.notices.push(alert);
                }
            });

            this.loading = false;
        }
    },
    watch: {
        $route() {
            this.$store.dispatch("AlertStore/getTotals");
        }
    },
    mounted() {
        // Allow any other component to emit this event on the global event bus.
        this.$root.$on('showAlerts', this.showTab);
    }
}
</script>
<style scoped>
.alert-button {
    margin: 2px
}
</style>
